import { render, staticRenderFns } from "./update-photo.vue?vue&type=template&id=12876794&scoped=true&lang=pug&"
import script from "./update-photo.vue?vue&type=script&lang=js&"
export * from "./update-photo.vue?vue&type=script&lang=js&"
import style0 from "./update-photo.vue?vue&type=style&index=0&id=12876794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12876794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12876794')) {
      api.createRecord('12876794', component.options)
    } else {
      api.reload('12876794', component.options)
    }
    module.hot.accept("./update-photo.vue?vue&type=template&id=12876794&scoped=true&lang=pug&", function () {
      api.rerender('12876794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photos/update/update-photo.vue"
export default component.exports